/* Psiqueactiva · comportamientos compartidos (adaptado a Shopify).
   - La navegación viene del snippet psi-header.
   - En el EDITOR de temas todo se muestra al instante (sin animación de entrada),
     y se reinicializa cuando el editor redibuja, agrega u oculta una sección/bloque.
   - En navegadores embebidos (Instagram, Facebook, TikTok, etc.) las animaciones de
     entrada se desactivan por completo: esos navegadores no ejecutan
     IntersectionObserver de forma fiable y el contenido quedaba invisible. */
(function(){
function isEditor(){ return !!(window.Shopify && window.Shopify.designMode); }

// Navegadores dentro de apps (Instagram, Facebook, Messenger, TikTok, etc.)
function esNavegadorEmbebido(){
  var ua = navigator.userAgent || '';
  return /Instagram|FBAN|FBAV|FB_IAB|FBIOS|Messenger|Line\/|Twitter|TikTok|Pinterest|LinkedInApp|WhatsApp|Snapchat/i.test(ua);
}

// Casos en los que NO debemos ocultar nada para animarlo después
function sinAnimacion(){
  return esNavegadorEmbebido() || !('IntersectionObserver' in window);
}

function revelarTodo(){
  document.querySelectorAll('.reveal').forEach(function(el){
    el.style.transition = 'none';
    el.style.opacity = '1';
    el.style.transform = 'none';
    el.classList.add('in');
  });
}

function init(){
  // La clase 'js' es la que activa el CSS que esconde los .reveal.
  // Solo la ponemos si de verdad vamos a poder revelarlos después.
  if (!document.hidden && !sinAnimacion()) document.documentElement.classList.add('js');

  // Editor de temas y navegadores embebidos: mostrar todo de inmediato.
  if (isEditor() || sinAnimacion()){
    revelarTodo();
  }

  // Header scroll state
  const nav = document.getElementById('nav');
  if (nav && !nav.dataset.psiBound){
    nav.dataset.psiBound = '1';
    const onScroll = () => nav.classList.toggle('scrolled', window.scrollY > 8);
    onScroll(); window.addEventListener('scroll', onScroll, { passive:true });
  }

  // Mobile menu
  const menuBtn = document.getElementById('menuBtn');
  const mobileMenu = document.getElementById('mobileMenu');
  if (menuBtn && mobileMenu && !menuBtn.dataset.psiBound){
    menuBtn.dataset.psiBound = '1';
    menuBtn.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('open');
      menuBtn.setAttribute('aria-expanded', open);
    });
    mobileMenu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
      mobileMenu.classList.remove('open');
      menuBtn.setAttribute('aria-expanded', 'false');
    }));
  }

  // FAQ accordion
  document.querySelectorAll('.faq-q').forEach(q => {
    if (q.dataset.psiBound) return;
    q.dataset.psiBound = '1';
    q.addEventListener('click', () => {
      const open = q.getAttribute('aria-expanded') === 'true';
      const a = q.nextElementSibling;
      q.setAttribute('aria-expanded', !open);
      a.style.maxHeight = open ? null : a.scrollHeight + 'px';
    });
  });

  // Ni en el editor ni en navegadores embebidos animamos
  if (isEditor() || sinAnimacion()) return;

  // Reveal on scroll (tienda real)
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.reveal:not(.in)').forEach((el, i) => {
    el.style.transitionDelay = (Math.min(i % 4, 3) * 70) + 'ms';
    io.observe(el);
  });

  // Seguro 1: lo que ya está en pantalla se muestra sí o sí.
  setTimeout(() => document.querySelectorAll('.reveal:not(.in)').forEach(el => {
    const r = el.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0){
      el.style.transition = 'none';
      el.classList.add('in');
    }
  }), 1400);

  // Seguro 2: si pasados 2,5 s no se reveló absolutamente nada, el observer no
  // está funcionando en este navegador. Mostramos todo antes de dejar la página
  // en blanco. Mejor sin animación que invisible.
  setTimeout(function(){
    if (!document.querySelector('.reveal.in')) revelarTodo();
  }, 2500);
}
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Editor de temas: reinicializar al cargar/seleccionar/reordenar secciones y bloques
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
  document.addEventListener('shopify:block:select', init);
})();
